import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import './../../Style/AccountingSheetStyle.scss'
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import { deleteAlert, errorAlert, updateAlert, handleSuccess } from "../../Components/Alerts";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import jwtDecode from "jwt-decode";
import { AiFillEdit, AiFillAppstore } from "react-icons/ai";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Paper } from "@mui/material";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
// import { Link } from "react-router-dom";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import DataGridWithActions from "../../Components/DataGridWithActions";
import { AccountingSheetGridHeader } from "./AccountingSheetGridHeader";
import Autocomplete from "@mui/material/Autocomplete";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddLinkButton } from "../../Components/AddElementsButton";
import OneFieldTotal from "../../Components/OneFieldTotal";

export default function AccountingSheets(props) {
    const [showDetails, setShowDetails] = useState(true);

    const loginEmail = LoginUserDetailed();
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext)

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const [logedEmail, setLogedEmail] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            setLogedEmail(decodedToken.email);
        }
    }, []);


    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        TransactionID: "",
        InvoiceNr: "",
        Date: "",
        Coment: "",
        ModifiedByUser: ""
    });

    const [formTableData, setFormTableData] = useState({
        JournalID: "",
        InvoiceNr: "",
        LedgerID: "",
        AccountID: "",
        Comment: "",
        Debit: "",
        Credit: "",
        Total: "",
        ModifiedByUser: ""
    })

    // const [invoiceNR, setInvoiceNR] = useState("");
    const [actionType, setActionType] = useState("");
    const [ledgerID, setLedgerID] = useState("");
    const [accountID, setAccountID] = useState();
    const [amount0, setAmount0] = useState(0);

    // array per mbajtjen e te dhenave te tabeles qe shfaqet ne editim
    const [tableData, setTableData] = useState([]);
    const [ledgersID, setLedgersID] = useState([]);
    const [accountsID, setAccountsID] = useState([]);
    const [accountsID2, setAccountsID2] = useState([]);

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [showDeleteConfirmationDetails, setShowDeleteConfirmationDetails] = useState(false);

    const [deleteItemIdDetails, setDeleteItemIdDetails] = useState(null);

    const [showEditModal, setShowEditModal] = useState(false);

    const [showEditForm, setShowEditForm] = useState(false);
    const [showInserForm, setShowInsertForm] = useState(true);// Fillimisht është e shfaqur


    const [creditTotal, setCreditTotal] = useState([]);
    const [debitTotal, setDebitTotal] = useState([]);
    const [balance, setBalance] = useState(0);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingSheet', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // //Kodi per shfaqjen e tabeles ne Print
    const tableRef = useRef();

    //Kodi per pegination ne tabel
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenForm2 = () => {
        setShowInsertForm(true);
        setShowEditForm(false); // I fsheh formën e parë
    };
    const handleOpenForm1 = () => {
        setShowInsertForm(false);
        setShowEditForm(true); // I fsheh formën e parë
    };

    //Kodi per dizajnin e tabeles
    const styles = {
        tableHeader: {
            backgroundColor: '#284945',
            color: 'white',

        },
        tableCell: {
            paddingTop: '1px',
            paddingBottom: '1px',

        },

    };
    //Kodi per shfaqjen e loadingut 
    const [loading, setLoading] = useState(true);

    // Kodi per fshirjen e nje elementi ne databaz 
    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'AccountingSheet' + `/${deleteItemId}`, { headers }
            );
            setShowDeleteConfirmation(false);
            deleteAlert("Accounting sheet deleted Successfully");
            fetchData();
        } catch (error) {
            deleteAlert("Accounting sheet can not be deleted");
        }
    };
    const handleDeleteDetail = async () => {
        try {
            const response = await axios.delete(
                ApiLink.API_URL + 'AccountingSheet/onelineEdit' + `/${deleteItemIdDetails}`, { headers, params: { email: logedEmail, invoiceNR: formData.InvoiceNr, fiscalYear: fiscalYear } }
            );

            if (response.status === 200) {
                setShowDeleteConfirmationDetails(false);
                deleteAlert("Accounting sheet deleted Successfully");
                fetchTableData();
                fetchDataCreditTotal();
                fetchDataDebitTotal();
                fetchData();
            } else {
                errorAlert("Accounting sheet can not be deleted");
                setShowDeleteConfirmationDetails(false);

            }
        } catch (error) {
            errorAlert("An error occurred while trying to delete the accounting sheet");
        }
    };

    const fetchTableData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingSheet/journalaccountingsheets', { headers, params: { invNumber: formData.InvoiceNr, fiscalYear: fiscalYear } });
            setTableData(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleNewSubmit = (event) => {
        event.preventDefault();
        if (!formData.InvoiceNr) {
            errorAlert("Ju lutem plotësoni numrin e faturës!");
            return;
        }
        if (!ledgerID) {
            errorAlert("Ju lutem zgjedheni llogarinë kontabel");
            return;
        }
        if (!actionType) {
            errorAlert("Ju lutem zgjedheni tipin Debi/Kredi!");
            return;
        }
        if (!amount0) {
            errorAlert("Ju lutem plotesoni vlerën");
            return;
        }
        const stateDate = {
            Date: formData.Date,
            ActionType: actionType,
            InvoiceNr: formData.InvoiceNr,
            CreatedByUser: logedEmail,
            LedgerID: ledgerID,
            AccountID: accountID,
            Amount0: amount0
        };
        axios.post(ApiLink.API_URL + 'AccountingSheet/createnewline', stateDate, { headers })
            .then(() => {
                handleSuccess("Accounting Sheet Added Successfully");
                setAccountID();
                setActionType("");
                setLedgerID("");
                setAmount0(0);
                fetchData();
                fetchTableData();
                fetchDataCreditTotal();
                fetchDataDebitTotal();
                setfield(null);
                setAccountFields(null);
            })
            .catch((error) => {
                console.error(error);
                if (error.response && error.response.status === 409) {
                    errorAlert(error.response.data);
                } else {
                    errorAlert("An unknown error occurred while processing the request.");
                }
            });
    }


    const handleEditTableData = (item) => {
        handleOpenForm1();
        setFormTableData({
            JournalID: item.JournalID,
            InvoiceNr: item.InvoiceNr,
            LedgerID: item.LedgerID,
            AccountID: item.AccountID,
            Comment: item.Comment,
            Total: creditTotal,
            Credit: item.Credit,
            Debit: item.Debit,
            ModifiedByUser: loginEmail,

        })
    }
    const handleInputChangeTableData = (event) => {
        const { name, value } = event.target;
        setFormTableData({ ...formTableData, [name]: value });
    };

    const handleSubmitTableData = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'AccountingSheet/AccountingSheetDetailsUpdate', formTableData, { headers, params: { fiscalYear: fiscalYear } })
            .then((response) => {
                // console.log(response.data);
                fetchData();
                fetchTableData();
                fetchDataCreditTotal();
                fetchDataDebitTotal();
                updateAlert("Detail updated successfully");
                handleOpenForm2();

            })
            .catch((error) => {
                // alert("Failed to update State");
                errorAlert("Failed to update details")
            });
    }


    // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setFormData({
            TransactionID: item.TransactionID,
            InvoiceNr: item.InvoiceNr,
            Date: item.Date,
            Coment: item.Coment,
            ModifiedByUser: loginEmail,
        });
        setShowEditModal(true);
        setShowDetails(false);
        handleOpenForm2();

    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'AccountingSheet/AccountingSheetTransaction', formData, { headers })
            .then((response) => {
                // console.log(response.data);
                // setShowEditModal(false); 
                updateAlert("Accounting sheet updated successfully");
                fetchData();
                fetchTableData();
            })
            .catch((error) => {
                // alert("Failed to update State");
                errorAlert("Failed to update Accounting sheet")
            });
    };

    const fetchaccounts = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Ledger/accountsbyledgerid', { headers, params: { email: logedEmail, ledgerID: formTableData.LedgerID } });
            setAccountsID(response.data);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errorMessage) {
            } else {
                // errorAlert("Gabim në marrjen e të dhënave!");
            }
        }
    };

    const fetchaccounts2 = async (ledger) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Ledger/accountsbyledgerid', { headers, params: { email: logedEmail, ledgerID: ledger } });
            setAccountsID2(response.data);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errorMessage) {
            } else {
                // errorAlert("Gabim në marrjen e të dhënave!");
            }
        }
    };


    useEffect(() => {
        axios.get(ApiLink.API_URL + 'ledger', { headers })
            .then((response) => {
                setLedgersID(response.data);
            }).catch(() => {
                // errorAlert(error);
            })
    }, [])

    const fetchDataCreditTotal = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingSheet/CreditTOT', { headers, params: { email: logedEmail, invNumber: formData.InvoiceNr, fiscalYear: fiscalYear } });
            setCreditTotal(response.data);
            setLoading(false);

            // Kontrollo nëse nuk ka të dhëna të disponueshme
            if (response.data.length === 0) {
                // Shfaqi një mesazh për përdoruesin
                // errorAlert("No data available.");

            }
        } catch (error) {
            // Shfaqi një mesazh për përdoruesin për gabimin e tjera
            // setMessage("Error: Failed to fetch data.");
        }
    };

    const fetchDataDebitTotal = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingSheet/DebitTOT', { headers, params: { email: logedEmail, invNumber: formData.InvoiceNr, fiscalYear: fiscalYear } });
            setDebitTotal(response.data);
            setLoading(false);

            // Kontrollo nëse nuk ka të dhëna të disponueshme
            if (response.data.length === 0) {
                // Shfaqi një mesazh për përdoruesin
                // errorAlert("No data available.");

            }
        } catch (error) {
            // Shfaqi një mesazh për përdoruesin për gabimin e tjera
            // setMessage("Error: Failed to fetch data.");
        }
    };

    useEffect(() => {
        const calculatedBalance = creditTotal - debitTotal;
        setBalance(calculatedBalance);
    }, [creditTotal, debitTotal]);

    const totalAmount = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Total), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        inv: item.ActionType + "-" + item.FiscalYear + "-" + item.InvoiceNr,
        date: (item.Date.substring(0, 10)),
        description: item.Coment,
        total: item.Total,
        deleteItemId: item.TransactionID,
        rowInfo: item
    }));

    //Pjesa per select input field Clients
    const [field, setfield] = useState(null);
    const handleAutocompleteChangeInsertLedgers = (event, value) => {
        if (value && value.LedgerID) {
            setLedgerID(value.LedgerID);
            setfield(value); // Përditëso `selectedArticle` me vlerën e zgjedhur
            fetchaccounts2(value.LedgerID);

        } else {
            // Në rast se vlera është pastruar
            setLedgerID(0); // Vendos vlerën e ArticleID në null
            setfield(null);  // Pastro `Autocomplete`

        }
    };

    const defaultPropsInsertLedgers = {
        options: ledgersID,
        getOptionLabel: (option) =>
            option.LedgerNameEN || ""
    };
    //////


    //Select list for Clients
    const handleAutocompleteChangeLedgers = (event, value) => {
        if (value) {
            setFormTableData(prevState => ({
                ...prevState,
                LedgerID: value.LedgerID
            }));
            fetchaccounts();

        } else {
            setFormTableData(prevState => ({
                ...prevState,
                LedgerID: ""
            }));
        }
    };

    const defaultPropsLedgers = {
        options: ledgersID,
        getOptionLabel: (option) =>
            option.LedgerNameEN || ""
    };

    //Kodi i seelect list per insetim te accounts
    const [accountsField, setAccountFields] = useState(null);
    const handleAutocompleteChangeInsertAccounts = (event, value) => {
        if (value && value.AccountID) {
            setAccountID(value.AccountID);
            setAccountFields(value); // Përditëso `selectedArticle` me vlerën e zgjedhur

        } else {
            // Në rast se vlera është pastruar
            setAccountID(""); // Vendos vlerën e ArticleID në null
            setAccountFields(null);  // Pastro `Autocomplete`

        }
    };

    const defaultPropsInsertAccounts = {
        options: accountsID2,
        getOptionLabel: (option) =>
            option.AccountName || ""
    };


    //Kodi i seelect list per editim te accounts
    const handleAutocompleteChangeAccounts = (event, value) => {
        if (value) {
            setFormTableData(prevState => ({
                ...prevState,
                AccountID: value.AccountID
            }));

        } else {
            setFormTableData(prevState => ({
                ...prevState,
                AccountID: ""
            }));
        }
    };

    const defaultPropsAccounts = {
        options: accountsID,
        getOptionLabel: (option) =>
            option.AccountName || ""
    };



    useEffect(() => {
        fetchData();
        fetchTableData();
        fetchaccounts();
        // fetchaccounts2();
        fetchDataCreditTotal();
        fetchDataDebitTotal();
    }, [logedEmail, formData.InvoiceNr, formTableData.LedgerID, ledgerID, fiscalYear]);

    return (
        <div className="AccountingSheet__Container">
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteConfirmationDetails} onHide={() => setShowDeleteConfirmationDetails(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation 2</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmationDetails(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDeleteDetail}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <br></br>
            <br></br>
            {showEditModal && (
                <Paper>
                    <form onSubmit={handleSubmit} className='header_paper'>
                        <Box
                            // component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div className='AccountingSheet__Container__Form'>
                                <div >
                                    <TextField
                                        className="AccountingSheet__Container__Form__TextField__1"
                                        id="InvoiceNr"
                                        label="Invoice Number"
                                        variant="outlined"
                                        type="text"
                                        name='InvoiceNr'
                                        value={"ACS-" + fiscalYear + "-" + formData.InvoiceNr}
                                        onChange={handleInputChange}
                                        disabled
                                    />
                                </div>
                                <div >
                                    <TextField
                                        className="AccountingSheet__Container__Form__TextField__2"
                                        id="Date"
                                        type="date"
                                        variant="outlined"
                                        name='Date'
                                        value={formData.Date.substring(0, 10)}
                                        onChange={handleInputChange}
                                        inputProps={{
                                            min: minDate, // Kufizimi minimal i datës
                                            max: maxDate, // Kufizimi maksimal i datës
                                        }}
                                    />
                                </div>
                                <div>
                                    <div>
                                        <TextField
                                            className="AccountingSheet__Container__Form__TextField__3"
                                            id="Coment"
                                            select
                                            label="Komenti"
                                            name='Coment'
                                            // defaultValue=""
                                            value={formData.Coment}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value="Open Accounts">Hapje e Llogarive</MenuItem>
                                            <MenuItem value="Balance Accounts">Barazim i Llogarive</MenuItem>
                                            <MenuItem value="Closed Accounts">Mbyllje e Llogarive</MenuItem>
                                        </TextField>
                                    </div>
                                </div>
                                <button type="submit"
                                    className="btn btn-primary"
                                    style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                >Ndrysho</button>
                            </div>
                        </Box>
                    </form>
                    <br></br>
                    <br></br>
                    {showEditForm && (
                        <form onSubmit={handleSubmitTableData} className='header_paper'>
                            <Box
                                // component="form"
                                sx={{
                                    '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div className='AccountingSheet__Container__Form'>
                                    <div>
                                        <Autocomplete
                                            fullWidth
                                            // sx={{ m: 2 }}
                                            {...defaultPropsLedgers}
                                            id="LedgerID"
                                            includeInputInList
                                            onChange={handleAutocompleteChangeLedgers}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label="Lloji llogarisë"
                                                    // variant="filled"
                                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                            value={ledgersID.find(option => option.LedgerID === formTableData.LedgerID) || null}
                                        />
                                    </div>
                                    <div>
                                        <Autocomplete
                                            fullWidth
                                            // sx={{ m: 2 }}
                                            {...defaultPropsAccounts}
                                            id="AccountID"
                                            includeInputInList
                                            onChange={handleAutocompleteChangeAccounts}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label="Llogaria"
                                                    // variant="filled"
                                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                            value={accountsID.find(option => option.AccountID === formTableData.AccountID) || null}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            className="AccountingSheet__Container__Form__TextField__5"
                                            id="Comment"
                                            name="Comment"
                                            select
                                            label="Debit/Credit"
                                            defaultValue=""
                                            // helperText="Please select expense"
                                            value={formTableData.Comment}
                                            onChange={handleInputChangeTableData}
                                        >
                                            <MenuItem value="Debit">Debit</MenuItem>
                                            <MenuItem value="Credi">Credit</MenuItem>
                                        </TextField>
                                    </div>
                                    {/* // Pasi të keni vendosur vlerat, shfaqeni ato në elementin 'TextField' */}
                                    <div className='box3'>
                                        <TextField
                                            className="AccountingSheet__Container__Form__TextField__5"
                                            id="Debit"
                                            label="Total"
                                            variant="outlined"
                                            name={formTableData.Comment === 'Debit' ? 'Debit' : 'Credit'}
                                            value={formTableData.Comment === 'Debit' ? formTableData.Debit : formTableData.Credit}
                                            onChange={handleInputChangeTableData}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="butonat">
                                        <button type="submit"
                                            className="btn btn-primary float-end"
                                            style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                        >Save</button>
                                    </div>
                                </div>
                                <br></br>
                            </Box>
                        </form>
                    )}

                    {showInserForm && (
                        <form onSubmit={handleNewSubmit} className='header_paper'>
                            <Box
                                // component="form"
                                sx={{
                                    '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div className='AccountingSheet__Container__Form'>
                                    <div>
                                        <Autocomplete
                                            fullWidth
                                            {...defaultPropsInsertLedgers}
                                            id="include-input-in-list"
                                            includeInputInList
                                            value={field}  // Lidheni me state-in `selectedArticle`
                                            onChange={handleAutocompleteChangeInsertLedgers}
                                            isOptionEqualToValue={(option, value) => option.LedgerID === value.LedgerID} // Shto funksionin isOptionEqualToValue
                                            renderInput={(params) => (
                                                <TextField
                                                    // style={{ width: "91%" }}
                                                    className="AddPurchaseTotal__Container__Format__SameInput"

                                                    {...params}
                                                    label="Përzgjedh llogarinë Kontabel"
                                                // variant="filled"
                                                //   onKeyPress={handleKeyPress}
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <Autocomplete
                                            fullWidth
                                            {...defaultPropsInsertAccounts}
                                            id="include-input-in-list"
                                            includeInputInList
                                            value={accountsField}  // Lidheni me state-in `selectedArticle`
                                            onChange={handleAutocompleteChangeInsertAccounts}
                                            isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                            renderInput={(params) => (
                                                <TextField
                                                    // style={{ width: "91%" }}
                                                    className="AddPurchaseTotal__Container__Format__SameInput"

                                                    {...params}
                                                    label="Përzgjedh llogarinë"
                                                // variant="filled"
                                                //   onKeyPress={handleKeyPress}
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            className="AccountingSheet__Container__Form__TextField__5"
                                            id="ActionType"
                                            select
                                            label="Debi/Kredi"
                                            defaultValue=""
                                            // helperText="Please select expense"
                                            value={actionType}
                                            onChange={event => setActionType(event.target.value)}
                                        >
                                            <MenuItem value="Debit">Debit</MenuItem>
                                            <MenuItem value="Credi">Credit</MenuItem>
                                        </TextField>
                                    </div>
                                    <div className='box3'>
                                        <TextField
                                            className="AccountingSheet__Container__Form__TextField__5"
                                            id="outlined-basic"
                                            label="Vlera"
                                            variant="outlined"
                                            name='Amount0'
                                            value={amount0}
                                            onChange={event => setAmount0(event.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="butonat">
                                        <button type="submit"
                                            className="btn btn-primary float-end"
                                            style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                        >Shto</button>
                                    </div>
                                </div>
                                <br></br>
                            </Box>
                        </form>
                    )}
                    <TableContainer sx={{ maxHeight: 500 }}>
                        <Table ref={tableRef} stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={styles.tableHeader}><strong>Llogaria kontabel</strong></TableCell>
                                    <TableCell sx={styles.tableHeader}><strong>Llogaria</strong></TableCell>
                                    <TableCell sx={styles.tableHeader}><strong>Komenti</strong></TableCell>
                                    <TableCell sx={styles.tableHeader}><strong>Debi</strong></TableCell>
                                    <TableCell sx={styles.tableHeader}><strong>Kredi</strong></TableCell>
                                    <TableCell sx={styles.tableHeader}><strong>Veprimet</strong></TableCell>

                                </TableRow>
                            </TableHead>
                            {loading ? (
                                <div className="spinner" style={{ marginLeft: "560px" }} ></div>
                            ) : (
                                <TableBody>
                                    {tableData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((item) => (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={item.TransactionID}>
                                                <TableCell sx={styles.tableCell}>{item.LedgerNameEN}</TableCell>
                                                <TableCell sx={styles.tableCell}>{item.AccountName}</TableCell>
                                                <TableCell sx={styles.tableCell}>{item.Coment}</TableCell>
                                                <TableCell sx={styles.tableCell}>{item.Debit}</TableCell>
                                                <TableCell sx={styles.tableCell}>{item.Credit}</TableCell>
                                                <TableCell sx={styles.tableCell}>
                                                    <Tooltip title="Edit" placement="left">
                                                        <IconButton>
                                                            <AiFillEdit style={{ color: '#466F86' }} onClick={() => { handleEditTableData(item); handleOpenForm1(); }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" placement="right">
                                                        <IconButton>
                                                            <DeleteIcon style={{ color: '#962a38' }}
                                                                onClick={() => {
                                                                    setShowDeleteConfirmationDetails(true);
                                                                    setDeleteItemIdDetails(item.JournalID);
                                                                }}
                                                            />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                    {/* <DataGridWithActions
                        columns={detailsData}
                        rows={detailsRows}
                        handleEdit={handleEditTableData}
                        handleDelete={handleDeleteDetail}
                        showPayment={false}
                    /> */}

                    <div className="AccountingSheet__Container__Form__totalet">
                        <TextField
                            className="AccountingSheet__Container__Form__TextField__6"
                            id="DebitTotal"
                            label="Debit Total"
                            variant="outlined"
                            type="text"
                            value={debitTotal}
                            disabled
                        />

                        <TextField
                            className="AccountingSheet__Container__Form__TextField__7"
                            id="CreditTotal"
                            label="Credit Total"
                            variant="outlined"
                            type="text"
                            value={creditTotal}
                            disabled
                        />
                        <TextField
                            className="AccountingSheet__Container__Form__TextField__8"
                            id="Balance"
                            label="Balance"
                            variant="outlined"
                            type="text"
                            value={balance}
                            disabled
                        />
                        <div className="butonat">
                            {balance != 0 ? (

                                <div className="alert alert-danger">
                                    The balance must be 0 to close the accounting sheet
                                </div>
                            ) : (
                                <button
                                    className="btn btn-primary"
                                    style={{ background: "#284945", width: "110px", marginLeft: "100px" }}
                                    onClick={() => {
                                        setShowEditModal(false);
                                        setShowDetails(true);

                                    }}
                                >
                                    Mbyll
                                </button>

                            )}
                        </div>
                    </div>
                    <br></br>

                </Paper>
            )
            }

            {showDetails && (
                <div className="shfaqePermbajtjen">
                    <div className="header_flex">
                        {/* <div className="header_icon">
                            <AiFillAppstore style={{}} className="header_icons" />
                            <h3>Fletat kontabel</h3>
                        </div> */}
                        <TitleElements
                            icon={AiFillAppstore}
                            title="Fletat kontabel"
                        />
                        {/* <div>
                            <Link to={"/accounting/addaccountingsheets"}>
                                <button className="button-68">
                                    <i class="bi bi-plus-circle">  </i>  <span style={{ marginLeft: "5px" }} />  Krijo Fletë kontabel
                                </button>
                            </Link>
                        </div> */}
                        <AddLinkButton
                            text="Krijo Fletë kontabel"
                            icon="bi bi-plus-circle"
                            link="/accounting/addaccountingsheets"
                        />
                    </div>
                    {/* <div className="header_paragraph">
                        <p>Forma e Fletave kontabel: Menaxhoni, shtoni, editoni dhe fshini Fleta kontabel.</p>
                    </div> */}
                    <ElementsParagraph text="Forma e Fletave kontabel: Menaxhoni, shtoni, editoni dhe fshini Fleta kontabel." />


                    <DataGridWithActions
                        columns={AccountingSheetGridHeader}
                        rows={rows}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        showPayment={false}
                        height={500}
                    />

                    <OneFieldTotal
                        id={1}
                        label="Totali"
                        value={totalAmount}
                    />
                </div>
            )}
        </div >
    )
}